import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom';
import HeaderTopbar from '../HeaderTopbar/HeaderTopbar'
import MobileMenu from '../MobileMenu/MobileMenu'
import Logo from '../../images/logo.png'

const Header = (props) => {
    const [menuActive, setMenuState] = useState(false);
    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <header id="header" className="no-topbar">
            <div className="wpo-site-header compact-header">
                <HeaderTopbar />
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container">
                        <div className="row align-items-center">

                            <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                <div className="mobail-menu">
                                    <MobileMenu />
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 col-6">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home">
                                        <img src={Logo} alt="" />
                                    </Link>
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-1 col-1">
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                <ul className="nav navbar-nav mb-2 mb-lg-0">

<li>
    <NavLink onClick={ClickHandler} to="/" end>
        HOME
    </NavLink>
</li>

<li>
    <NavLink onClick={ClickHandler} to="/service">
        SERVICES
    </NavLink>
</li>

<li>
    <a
        href="https://lcs.cincwebaxis.com"
        target="_blank"
        rel="noopener noreferrer"
    >
        PAY MY ASSESSMENT
    </a>
</li>

<li>
    <NavLink onClick={ClickHandler} to="/about">
        ABOUT US
    </NavLink>
</li>

<li>
    <a
        href="https://secure.condocerts.com/resale/"
        target="_blank"
        rel="noopener noreferrer"
    >
        ORDER ESTOPPEL / RESALE CERTIFICATE
    </a>
</li>

<li>
    <NavLink onClick={ClickHandler} to="/contact">
        CONTACT US
    </NavLink>
</li>

<li>
    <a
        href="https://chrysalis-associates.web.app"
        target="_blank"
        rel="noopener noreferrer"
    >
        ADMIN PORTAL
    </a>
</li>

</ul>

                                </div>
                            </div>

                            <div className="col-lg-3 col-md-2 col-2">
                                <div className="header-right">

                                    <div className="header-search-form-wrapper">
                                        <div className="cart-search-contact">
                                            <button
                                                onClick={() => setMenuState(!menuActive)}
                                                className="search-toggle-btn"
                                            >
                                                <i className={`ti-search ${menuActive ? "ti-close" : "ti-search"}`}></i>
                                            </button>

                                            <div className={`header-search-form ${menuActive ? "header-search-content-toggle" : ""}`}>
                                                <form onSubmit={SubmitHandler}>
                                                    <div>
                                                        <input type="text" className="form-control" placeholder="Search here..." />
                                                        <button type="submit">
                                                            <i className="fi flaticon-loupe"></i>
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-12 text-center estimate-bar">
                                    <Link onClick={ClickHandler} className="theme-btn" to="/proposal">
    <span>Proposal Request</span>
</Link>

</div>


                                </div>
                            </div>

                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default Header;
